import { takeEvery, put } from 'redux-saga/effects';
import SuccessModal from 'components/common/modal/success-modal';
import FailedModal from 'components/common/modal/failed-modal';
import {} from 'constants/action-types';
import * as windowActions from 'components/common/modal/modal-actions';
import { Action } from 'types/action';
import { closeModal, closeAllModals, openModal } from 'components/common/modal/modal-actions';

const { closeWindow, closeAllWindows, openWindow } = windowActions;

function* closeModalWindow() {
  yield put(closeWindow());
}

function* closeAllModalWindows() {
  yield put(closeAllWindows());
}

function* openModalWindow(action: Action) {
  try {
    switch (action.type) {
      default:
        yield put(openWindow(action.meta.openNewModalOptions));
        break;
    }
  } catch (e) {
    console.log(`error modalSaga : openModalWindow error - ${e} action- ${action}`);
  }
}

function* closeNewModal() {
  yield put(closeModal());
}

function* closeAllNewModals() {
  yield put(closeAllModals());
}

function* openNewModal(action: Action) {
  yield put(openModal(action.meta.modalOptions));
}

function* closeThenOpenNewModal(action: Action) {
  yield put(closeAllModals());
  yield put(openModal(action.meta.modalOptions));
}

function* openSuccessModal(action: Action) {
  if (action?.meta?.modalOptions?.success) {
    const onSuccessModal = {
      modalClassName: action.meta.modalOptions.success.modalClassName || 'successModal',
      component: action.meta.modalOptions.success.modalComponent || (
        <SuccessModal
          bigText={action.meta.modalOptions.success.bigText}
          message={action.meta.modalOptions.success.message}
        />
      )
    };
    yield openNewModal({
      ...action,
      meta: {
        ...action.meta,
        modalOptions: onSuccessModal
      }
    });
  }
}

function* closeThenOpenNewSuccessModal(action: Action) {
  yield closeNewModal();
  if (action?.meta?.modalOptions?.success) {
    const onSuccessModal = {
      modalClassName: action.meta.modalOptions.success.modalClassName || 'successModal',
      component: action.meta.modalOptions.success.modalComponent || (
        <SuccessModal
          bigText={action.meta.modalOptions.success.bigText}
          message={action.meta.modalOptions.success.message}
        />
      )
    };
    yield openNewModal({
      ...action,
      meta: {
        ...action.meta,
        modalOptions: onSuccessModal
      }
    });
  }
}

function* openSuccessModalWithCloseAll(action: Action) {
  if (action?.meta?.modalOptions?.success) {
    const onSuccessModal = {
      modalClassName: action.meta.modalOptions.success.modalClassName || 'successModal',
      component: action.meta.modalOptions.success.modalComponent || (
        <SuccessModal
          bigText={action.meta.modalOptions.success.bigText}
          message={action.meta.modalOptions.success.message}
          onConfirm={action?.meta?.modalOptions?.success?.onConfirm || undefined}
        />
      )
    };
    yield closeThenOpenNewModal({
      ...action,
      meta: {
        ...action.meta,
        modalOptions: onSuccessModal
      }
    });
  }
}

function* openFailedModal(action: Action) {
  if (action?.meta?.modalOptions?.failed) {
    const onFailedModal = {
      modalClassName: action.meta.modalOptions.failed.modalClassName || 'failedModal',
      component: action.meta.modalOptions.failed.modalComponent || (
        <FailedModal bigText={action.meta.modalOptions.failed.bigText} />
      )
    };
    yield openNewModal({
      ...action,
      meta: {
        ...action.meta,
        modalOptions: onFailedModal
      }
    });
  }
}

export default function* modalSaga() {
  yield takeEvery([], closeModalWindow);

  yield takeEvery([], closeNewModal);

  yield takeEvery([], closeAllModalWindows);

  yield takeEvery([], openModalWindow);

  yield takeEvery([], openNewModal);

  yield takeEvery([], closeThenOpenNewModal);

  yield takeEvery([], closeAllNewModals);

  yield takeEvery([], closeThenOpenNewSuccessModal);
  yield takeEvery([], openSuccessModalWithCloseAll);
  yield takeEvery([], openSuccessModal);
  yield takeEvery([], openFailedModal);
}
